<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      class="elevation-1"
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.invoice_number }}</td>
        <td>{{ getAnswerItem(props.item.answers, 'main_form', 'deceased_location_of_wake') }}</td>
        <td>{{ props.item.plan ? props.item.plan.name : '-' }}</td>
        <td>{{ props.item.manager_name }}</td>
        <td>{{ props.item.wake_start }}</td>
        <td>{{ props.item.status }}</td>
        <td class="justify-left layout px-0">

          <v-tooltip top v-if="!crewSelecting">
            <v-btn slot="activator" v-if="detailCaseButtonActionIsDefault" icon class="mx-0" @click="goCasesDetail(props.item.id)">
              <v-icon color="indigo">remove_red_eye</v-icon>
            </v-btn>
            <v-btn slot="activator" v-if="detailCaseButtonActionIsGoToCheckListsTab" icon class="mx-0" @click="goCasesDetailCheckListsTab(props.item.id)">
              <v-icon color="indigo">remove_red_eye</v-icon>
            </v-btn>
            <v-btn slot="activator" v-if="detailCaseButtonActionIsGoToInvoicesTab" icon class="mx-0" @click="goCasesDetailInvoicesTab(props.item.id)">
              <v-icon color="indigo">remove_red_eye</v-icon>
            </v-btn>
            View details
          </v-tooltip>

          <v-tooltip v-if="crewSelecting" top>
            <v-btn slot="activator" icon class="mx-0" @click="selectCrew(props.item.id)" :disabled="props.item.status === 'closed'">
              <v-icon color="teal" v-if="props.item.status === 'closed'">group</v-icon>
              <v-icon color="teal" v-else>group_add</v-icon>
            </v-btn>
            {{ props.item.status === 'closed' ? 'Case Closed' : 'Select Crew' }}
          </v-tooltip>

          <v-tooltip v-if="$can('send', 'cases-client-email') && !crewSelecting" top>
            <v-btn slot="activator" icon class="mx-0" @click="sendQuotationMailToClient(props.item.id)" :disabled="disabled.sendQuotationMailToClientBtn">
              <v-icon color="teal">mail</v-icon>
            </v-btn>
            Email quotation to client
          </v-tooltip>

          <v-tooltip top v-if="!crewSelecting">
            <v-btn slot="activator" icon class="mx-0" @click="closeCase(props.item.id)" v-show="$can('close', 'cases-item') && props.item.status !== 'closed'">
              <v-icon color="light-green">done</v-icon>
            </v-btn>
            Close case
          </v-tooltip>

          <v-tooltip top v-if="!crewSelecting">
            <v-btn slot="activator" icon class="mx-0" @click="deleteCaseElement(props.item.id)" v-show="$can('delete', 'cases-item')">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            Delete case
          </v-tooltip>
          <ConfirmationDialog ref="confirm" />
        </td>
      </template>
    </v-data-table>
    <v-layout class="mt-4" v-if="!loadingInProgress">
      <v-flex class="text-sm-center">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          @input="onPageChange"
        />
      </v-flex>
    </v-layout>
    <AppEditCasesDialog />
    <CrewDialog />
    <v-dialog
      v-model="showAlert"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="flex-alert-center">
          <v-icon dark right class="flex-alert-notification-check">check_circle</v-icon> {{ alertMessage }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  // import resourcesMixins from '@/mixins/Resources'
  import vendorsAPI from '@/api/resources/vendors'
  import casesAPI from '@/api/resources/cases'
  import AppEditCasesDialog from '@/components/dialogs/AppEditCasesDialog'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'
  import CrewDialog from '@/components/dialogs/CrewDialog'
  import _ from 'lodash'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Cases',
    components: { AppEditCasesDialog, ConfirmationDialog, CrewDialog },
    // mixins: [ resourcesMixins ],
    data () {
      return {
        resources: 'cases',
        items: [],
        vendorItemsPromise: null,
        tableHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Invoice Number', value: 'invoice_number' },
          { text: 'Address', value: 'deceased_location_of_wake' },
          { text: 'Plan', value: 'plans_id' },
          { text: 'Case manager', value: 'users_id' },
          { text: 'Funeral date', value: 'deceased_date' },
          { text: 'Status', value: 'status' },
          { text: 'Actions', value: 'actions' }
        ],
        caseID: 0,
        currentUserServiceId: 0,
        clientName: '',
        dialogOpen: false,
        dialogMessage: '',
        vendorInventories: [],
        disabled: {
          sendQuotationMailToClientBtn: false
        },
        vendorServices: [],
        rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
        pagination: {
          descending: true,
          rowsPerPage: 10,
          sortBy: 'created_at',
          current: 1,
          total: 1
        },
        loadingInProgress: true,
        loadingItemsText: 'Loading data',
        showAlert: false,
        alertMessage: null
      }
    },
    watch: {
      getEditCrewDialog (v) {
        // if (!v) this.loadListing()
      }
    },
    computed: {
      ...mapGetters({
        getEditCrewDialog: 'getEditCrewDialog'
      }),
      isVendor () {
        return this.$store.getters.currentUserRoles.includes('vendor')
      },
      vendorInventoriesIDs () {
        return this.vendorInventories.map(item => item.id)
      },
      vendorServicesIDs () {
        return this.vendorServices.map(item => item.id)
      }
    },
    methods: {
      sendQuotationMailToClient (caseId) {
        this.$refs.confirm.open('Are you sure?', 'Send', {}).then((confirm) => {
          casesAPI.sendQuotationMailToClient(caseId).then(() => {
            // this.disabled.sendQuotationMailToClientBtn = true
            this.alertMessage = 'Email successfully sent!'
            this.showAlert = true
            setTimeout(() => {
              this.showAlert = false
            }, 2000)
          }, () => {})
        })
      },
      async checkCasePayment (caseId) {
        const apiUrl = this.$store.getters.config.api_host
        const response = await this.$axios.get(`${apiUrl}/api/cases/${caseId}`)
        if (response) {
          const paymentData = response.data && response.data.additional_data && response.data.additional_data[0] && JSON.parse(response.data.additional_data[0].payment_info)
          if (paymentData) {
            return paymentData
          } else {
            return { payment_method: null }
          }
        }
      },
      async closeCase (itemId) {
        const paymentData = await this.checkCasePayment(itemId)
        if (paymentData) {
          if (paymentData.payment_method) {
            this.$refs.confirm.open('Are you sure?', 'Close case', {}).then((confirm) => {
              casesAPI.closeCase(itemId).then(() => {
                this.loadCases()
                /*
                casesAPI.changeCaseManagerCommissions(itemId).then(() => {
                  this.loadListing()
                })
                */
              }, () => {})
            })
          } else {
            this.$refs.confirm.open('Payment method is missing for this case', 'Open Case Details', {}).then((confirm) => {
              this.goCasesDetail(itemId)
            })
          }
        }
      },
      handleLoadListingResult (result) {
        result.forEach((item, i) => {
          if ((this.isVendor && this.checkVendorAccessForItem(item)) || !this.isVendor) {
            item = this.parseOnBoardForm(item)
            this.items.push(item)
          }

          if (i === result.length - 1 && this.items.length === 0) {
            this.setNoItemsLoaded()
          }
        })
      },
      parseOnBoardForm (item) {
        item.deceased_location_of_wake = '-'
        item.deceased_date = '-'

        if ((item.answers !== undefined) && item.answers.length > 0) {
          let answers = _.sortBy(item.answers, 'created_at').reverse()
          let lastOnBoardForm = _.find(answers, f => f.form.name === 'OnBoardClient')
          if (lastOnBoardForm) {
            let onBoardForm = JSON.parse(lastOnBoardForm.answer).form_answers
            item.deceased_location_of_wake = onBoardForm.main_form.deceased_location_of_wake
            item.deceased_date = onBoardForm.main_form.deceased_date
          }
        }

        return item
      },
      checkVendorAccessForItem (caseRecord) {
        // let inventoriesIDs = caseRecord.inventories.map(item => item.id)
        let servicesIDs = caseRecord.services.map(item => item.id)
        //
        // if (inventoriesIDs.some(item => this.vendorInventoriesIDs.includes(item))) {
        //   return true
        // }

        return servicesIDs.some(item => this.vendorServicesIDs.includes(item))
      },
      goCasesDetail (itemId) {
        this.$router.push({
          name: 'CasesDetail',
          params: { id: itemId }
        })
      },
      goCasesDetailCheckListsTab (itemId) {
        this.$router.push({
          name: 'CasesDetail',
          params: { id: itemId, goToCheckListsTab: true }
        })
      },
      goCasesDetailInvoicesTab (itemId) {
        this.$router.push({
          name: 'CasesDetail',
          params: { id: itemId, goToInvoicesTab: true }
        })
      },
      loadListingSuccess (result) {
        if (this.isVendor) {
          this.vendorItemsPromise.then(vendorResult => {
            this.vendorInventories = vendorResult.inventories
            this.vendorServices = vendorResult.services

            this.handleLoadListingResult(result)
          }, () => {})
        } else {
          this.handleLoadListingResult(result)
        }
      },
      deleteCaseElement (id) {
        this.$refs.confirm.open('Are you sure?', 'Delete', {}).then((confirm) => {
          this.deleteCase(id)
        })
      },
      async deleteCase (id) {
        const response = await this.$axios.delete(`${this.$store.getters.config.api_host}/api/cases/${id}`)
        if (response) {
          this.loadCases()
        }
      },
      selectCrew (id) {
        const selectedCase = this.items.find(i => i.id === id)
        this.$store.commit('unsetEditCaseCrewId')
        this.$store.commit('setCrewDialogCase', selectedCase)
        setTimeout(() => {
          this.$store.commit('setEditCaseCrewId', id)
          this.$store.commit('switchCrewDialog')
        }, 500)
      },
      async onPageChange () {
        this.loadingInProgress = true
        const response = await this.$axios.get(`${this.$store.getters.config.api_host}/api/cases/paginated?page=${this.pagination.current}`)
        if (response) {
          this.items = response.data.additional_data.data
          this.pagination.total = response.data.additional_data.last_page
          this.loadingInProgress = false
        }
      },
      async loadCases () {
        const response = await this.$axios.get(`${this.$store.getters.config.api_host}/api/cases/paginated?page=${this.pagination.current}`)
        if (response) {
          this.items = response.data.additional_data.data
          this.pagination.total = response.data.additional_data.last_page
          this.loadingInProgress = false
        }
      },
      getAnswerItem (answers, form, field) {
        const parsed = answers[0] ? JSON.parse(answers[0].answer) : null
        return parsed && parsed.form_answers[form][field] ? parsed.form_answers[form][field].replace(',', ';') : '-'
      }
    },
    created () {
      if (this.isVendor) {
        this.vendorItemsPromise = vendorsAPI.getVendorItems(this.$store.getters.currentUser.id)
      }
    },
    mounted () {
      this.loadCases()
    },
    props: {
      detailCaseButtonActionIsDefault: {
        type: Boolean,
        default: false,
        required: false
      },
      detailCaseButtonActionIsGoToCheckListsTab: {
        type: Boolean,
        default: false,
        required: false
      },
      detailCaseButtonActionIsGoToInvoicesTab: {
        type: Boolean,
        default: false,
        required: false
      },
      crewSelecting: {
        type: Boolean,
        default: false,
        required: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Cases.vue?ecfafbb6